import { Spacer, Text } from '@nextui-org/react';
import classes from 'components/Message/Message.module.css';
import { BsHeartFill } from 'react-icons/bs';

const MessageScreen = () => {
  return (
    <div className={classes.main}>
      <div style={{
        height: '60px',
      }} className={classes.heart}>
        <BsHeartFill color="red" />
      </div>
      
    </div>
  );
};

export default MessageScreen;
